<script>
export default {
  props: ["modalParams"],
  template: "#edit-post-modal",
  data () {
    return {};
  },
  created () {
    this.postDataId = "discussion_post_" + this.modalParams.postId;
  },
  methods: {
    submit () {
      this.$refs.form.submit();
    }
  }
};
</script>
